import React, { Fragment } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { faPlus, faEdit } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import WithToggle from "./WithToggle";
import ScooterForm from "./ScooterForm";
import {
  compose,
  withHandlers,
  setDisplayName,
  lifecycle,
  defaultProps,
  withProps
} from "recompose";
import { connect } from "react-redux";
import { actions } from "../modules/scooters";
import { isFunction, pick } from "lodash";
import Card from "./Card";

const mapStateToProps = state => ({
  submittingScooter: state.scooters.submittingScooter,
  failSubmitScooter: state.scooters.failSubmitScooter,
  successSubmitScooter: state.scooters.successSubmitScooter,
  currentDealer: state.dealers.currentDealer,
  currentCustomer: state.customers.currentCustomer,
  currentScooter: state.scooters.currentScooter
});

const mapDispatchToProps = {
  createScooter: actions.createScooter,
  updateScooter: actions.updateScooter,
  setCurrentScooter: actions.setCurrentScooter,
  resetState: actions.resetState
};

const withHandleSubmit = withHandlers({
  onSubmit: ({
    createScooter,
    updateScooter,
    currentDealer,
    currentScooter,
    currentCustomer,
    formAction,
    toggle,
    onSubmitSuccess
  }) => data => {
    if (currentScooter && formAction === "update") {
      updateScooter({
        customer_id: currentCustomer.id,
        dealer_id: currentDealer.id,
        data,
        scooter_id: currentScooter.id
      }).then(scooter => {
        toggle();
        isFunction(onSubmitSuccess) && onSubmitSuccess(scooter);
      });
    } else {
      createScooter({
        data,
        dealer_id: currentDealer.id,
        customer_id: currentCustomer.id
      }).then(scooter => {
        toggle();
        isFunction(onSubmitSuccess) && onSubmitSuccess(scooter);
      });
    }
  }
});

const enhanced = compose(
  setDisplayName("ScooterButton"),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  WithToggle,
  withHandleSubmit,
  withProps(({ formAction, resetState }) => ({
    icon: formAction === "create" ? faPlus : faEdit,
    action: formAction === "create" ? "Create" : "Update",
    resetState: resetState.bind(null, ["scooters", "currentScooter"])
  })),
  lifecycle({
    componentWillUnmount() {
      this.props.resetState();
    }
  }),
  defaultProps({
    actionType: "create"
  })
);

const initialValues = (formAction, currentScooter) =>
  formAction === "update" && currentScooter
    ? pick(currentScooter, [
        "vin",
        "license_plate",
        "brand",
        "model",
        "color",
        "year"
      ])
    : { vin: "", license_plate: "", brand: "", model: "", color: "", year: "" };

const ScooterButton = enhanced(
  ({
    formAction,
    show,
    children,
    toggledOn,
    toggle,
    submittingScooter,
    failSubmitScooter,
    onSubmit,
    currentScooter,
    resetState,
    action,
    icon
  }) => (
    <Fragment>
      <Modal isOpen={toggledOn} toggle={toggle} onExit={resetState}>
        <Card
          plain
          content={
            <div>
              <ModalHeader toggle={toggle}>
                <h3 className="title">
                  {action} Scooter <FontAwesomeIcon icon={icon} />
                </h3>
              </ModalHeader>
              <ModalBody>
                <ScooterForm
                  currentScooter={
                    currentScooter && formAction === "update"
                      ? currentScooter
                      : null
                  }
                  submittingScooter={submittingScooter}
                  failSubmitScooter={failSubmitScooter}
                  onSubmit={onSubmit}
                  initialValues={initialValues(formAction, currentScooter)}
                />
              </ModalBody>
            </div>
          }
        />
      </Modal>
      {children({ onClick: toggle, show })}
    </Fragment>
  )
);

export default ScooterButton;
